<div    class="mv-28 mct-flex mct-row mct-justify-end mct-items-stretch mct-gap-16">
  <p>
    {{ 'revenue.posted-batches.search-returned' | translate | ucfirst }} <strong>{{ searchResult?.TotalCount }}</strong>
    {{ 'revenue.posted-batches.detailed-transactions.detailed-transactions' | translate }}
  </p>
  <div>
    <wl-busy [show]="exporting"></wl-busy>
    <button pButton type="button" [disabled]="exporting" class="atlas-btn atlas-btn-primary" (click)="exportResults()">
      {{ 'revenue.posted-batches.export-results' | translate | uppercase }}
    </button>
  </div>
</div>

<div class="atlas-table">
  <p-table [showGridlines]="true" [value]="searchResult?.Result" [paginator]="true" [rows]="searchParams ? searchParams.PageSize : 20" [lazy]="true" [totalRecords]="searchResult?.TotalCount" (onLazyLoad)="lazyLoad($event)">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="ApplyDate">
          {{ 'revenue.posted-batches.apply-date' | translate | ucfirst }}
          <p-sortIcon field="ApplyDate"></p-sortIcon>
        </th>
        <th pSortableColumn="ProfileName">
          {{ 'revenue.posted-batches.detailed-transactions.profile-sort-name' | translate | ucfirst }}
          <p-sortIcon field="ProfileName"></p-sortIcon>
        </th>
        <th pSortableColumn="ProfileId">
          {{ 'revenue.posted-batches.detailed-transactions.profile-id' | translate | ucfirst }}
          <p-sortIcon field="ProfileId"></p-sortIcon>
        </th>
        <th pSortableColumn="TranType">
          {{ 'revenue.posted-batches.detailed-transactions.transaction-type' | translate | ucfirst }}
          <p-sortIcon field="TranType"></p-sortIcon>
        </th>
        <th pSortableColumn="BatchPosting">
          {{ 'revenue.posted-batches.batch-number' | translate | ucfirst }}
          <p-sortIcon field="BatchPosting"></p-sortIcon>
        </th>
        <th pSortableColumn="Account">
          {{ 'revenue.posted-batches.account-number' | translate | ucfirst }}
          <p-sortIcon field="Account"></p-sortIcon>
        </th>
        <th pSortableColumn="DebitAmount">
          {{ 'revenue.posted-batches.detailed-transactions.debit-amount' | translate | ucfirst }}
          <p-sortIcon field="DebitAmount"></p-sortIcon>
        </th>
        <th pSortableColumn="CreditAmount">
          {{ 'revenue.posted-batches.detailed-transactions.credit-amount' | translate | ucfirst }}
          <p-sortIcon field="CreditAmount"></p-sortIcon>
        </th>
        <th pSortableColumn="InvoiceNum">
          {{ 'revenue.posted-batches.detailed-transactions.invoice-number' | translate | ucfirst }}
          <p-sortIcon field="InvoiceNum"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-transaction>
      <tr>
        <td>{{ transaction.ApplyDate | date : 'MM/dd/yyyy' }}</td>
        <td>{{ transaction.ProfileName }}</td>
        <td>{{ transaction.ProfileId }}</td>
        <td>{{ transaction.TranType }}</td>
        <td>{{ transaction.BatchPosting }}</td>
        <td>{{ transaction.Account }}</td>
        <td>{{ transaction.DebitAmount | currency }}</td>
        <td>{{ transaction.CreditAmount | currency }}</td>
        <td>{{ transaction.InvoiceNum }}</td>
      </tr>
    </ng-template>
  </p-table>
<p-progressSpinner *ngIf="loading"></p-progressSpinner>
  <wl-page-size-dropdown [(pageSize)]="searchParams.PageSize" [pageSizes]="[20, 100, 0]"
    (pageSizeChange)="pageSizeChanged()"></wl-page-size-dropdown>
</div>